// extracted by mini-css-extract-plugin
module.exports = {"menu":"Menu-menu-3XXIf"};